module.exports = __webpack_public_path__ + "static/media/icon_trackrecord.4e57790d.svg";